import {
    clearHtmlBySelector,
    getBySelector,
    hideElementsBySelector, isVisibleBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {
    clearGeoJsonLayers,
    createGeoJsonLayer,
    removeGeoJsonLayer,
    toggleGeoJsonLayer
} from "@/helpers/ol/ol-geo-json-helper";
import {getToolsMutationSelectLayerValue} from "@/helpers/tools/tools-mutation-select-layer-helper";
import {LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon} from "ol/geom";
import {setDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {Feature} from "ol";
import {clearBuffer, measureBuffer, setBufferGeometry} from "@/helpers/measure/measure-buffer-helper";
import {getActiveLayers, getSnapLayers} from "@/helpers/ol/ol-layer-helper";
import {showNotification} from "@/helpers/notification-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {fromCircle} from "ol/geom/Polygon";

/**
 * Params
 */
let filterSelectLayerFeatures = []

/**
 * Filter geometry from map
 *
 * @returns {void}
 */
export function filterGeometryFromMap() {

    showElementsBySelector('#divFilterSelectLayer')
    getBySelector('#divFilterSelectLayerItems').innerHTML = ''
    getBySelector('#iptFilterSelectLayer').value = 1

    LoadFilterSelectOptions()
    changeSlcFilterSelectLayer()
}

/**
 * Get filter select layer value
 *
 * @returns {undefined|*}
 */
export function getFilterSelectLayerValue() {
    const element = getBySelector('#slcFilterSelectLayer')

    // Only show when filter menu is visible
    if(element && isVisibleBySelector('layer-info-filter-switcher')) {
        return element.value
    }
    return undefined
}

/**
 * Add filter select layer item
 *
 * @param items
 *
 * @param feature
 * @returns void
 */
export function addFilterSelectLayerItem(items, feature = undefined) {
    const bookmarkPresentationID = getFilterSelectLayerValue()

    // TODO: add multiple support. For this version we only support 1 item
    filterSelectLayerFeatures = []
    clearGeoJsonLayers()
    getBySelector('#divFilterSelectLayerItems').innerHTML = ''

    if(bookmarkPresentationID && items) {
        const mainTab = items.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === parseInt(bookmarkPresentationID))

        if(mainTab.features.length > 0) {
            feature = mainTab.features[0].feature
        }
    }

    if(feature) {

        let featureId
        let featureName
        if(feature.id) {
            featureId = feature.id
            featureName = featureId
        } else {
            featureId = 'draw'
            featureName = 'getekend'
        }

        if(getFeatureByID(featureId)) {
            showNotification('Dit object is al toegevoegd', '', 'warning')
            return
        }

        createGeoJsonLayer(feature, 'filter-select-layer-item-' + featureId, true)
        filterSelectLayerFeatures.push(feature)

        getBySelector('#divFilterSelectLayerItems').innerHTML +=
            `<div class="card card-hover-secondary mt-2">    
            <div class="card-header bg-lighter p-1">
                ${featureName}
                <button data-id="${featureId}" title="Verwijder uit active lagen" class="btn btn-sm borderless icon-btn float-right btnRemoveToolsMutationSelectLayerItem">
                    <span class="fa fa-times" data-id="${featureId}"></span>
                </button>
            </div>
        </div>`

        setFilterSelectLayerGeometry()

        const buffer = getBySelector('#iptFilterSelectLayer').value
        if(buffer !== '1') {
            setFilterSelectLayerBuffer(buffer)
        }
    }
}

/**
 * Get filter select layer multi polygon
 *
 * @param transformFrom
 * @param transformTo
 * @param multi
 * @returns {Point|[]|LineString|MultiPolygon}
 */
export function getFilterSelectLayerMultiPolygon(transformFrom = 'EPSG:28992', transformTo = undefined, multi =  false) {

    if(!transformTo) {
        transformTo = getViewProjectionName()
    }

    const features = []
    let geometry
    let type = ''

    filterSelectLayerFeatures.map(feature => {

        let coordinates
        if(feature.geometry) {
            type = feature.geometry.type
            coordinates = feature.geometry.coordinates
        } else {
            type = feature.getGeometry().getType()
            coordinates = feature.getGeometry().getCoordinates()
        }

        switch (type) {
            case 'Point':
                geometry = new Point(coordinates)
                break;
            case 'Polygon':
                geometry = new Polygon(coordinates)
                break;
            case 'LineString':
                geometry = new LineString(coordinates)
                break;
            case 'Circle':
                geometry = fromCircle(feature.getGeometry().clone())
                break;
        }

        if(type === 'MultiPolygon') {
            coordinates.map(coordinates => {
                features.push(new Polygon(coordinates).transform(transformFrom, transformTo))
            })
        } else {
            features.push(geometry.transform(transformFrom, transformTo))
        }
    })

    if(multi) {
        // console.log(type)
        if(type === 'Point') {
            return new Point(features[0].getCoordinates())
        }
        if(type === 'Polygon' || 'MultiPolygon') {
            return new MultiPolygon(features)
        }
        if(type === 'Circle') {
            return new MultiPolygon(features)
        }
        if(type === 'LineString') {
            return new LineString(features[0].getCoordinates())
        }
    }

    return features
}

/**
 * Toggle filter select layer
 *
 * @returns void
 */
export function setFilterSelectLayerGeometry() {
    setDrawGeometry(new Feature(getFilterSelectLayerMultiPolygon(getViewProjectionName(), getViewProjectionName(), true)), getViewProjectionName(), undefined, undefined, 'filter')
}


export function setFilterSelectLayerBuffer(buffer) {
    measureBuffer(getFilterSelectLayerMultiPolygon(getViewProjectionName()), buffer)

    setBufferGeometry()
}

export function clearFilterSelectLayer() {
    hideElementsBySelector('#divFilterSelectLayer')
    clearHtmlBySelector('#divFilterSelectLayerItems')
    clearHtmlBySelector('#iptFilterSelectLayer')
    // clearBuffer()
    filterSelectLayerFeatures = []
    clearGeoJsonLayers()
    hideElementsBySelector('#divPrintFilterCounter')
}

function getFeatureByID(id) {
    return filterSelectLayerFeatures.find(feature => feature.id === id)
}

export function removeFilterSelectLayerByID(id) {
    filterSelectLayerFeatures = filterSelectLayerFeatures.filter(feature => feature.id !== id)

    removeGeoJsonLayer('filter-select-layer-item-' + id)
    setFilterSelectLayerGeometry()
}

function changeSlcFilterSelectLayer() {
    if(window.result) {
        const element = document.querySelector('layer-info-info-item-header[class="active"]')
        let bookmarkPresentationName
        if(element) {
            bookmarkPresentationName = element.dataset.bookmarkPresentationName
        } else {
            bookmarkPresentationName = window.result.mainTabs.find(mainTab => mainTab.features.length > 0)
            if(bookmarkPresentationName) {
                bookmarkPresentationName = bookmarkPresentationName.BookmarkPresentationID
            }
        }


        if(bookmarkPresentationName) {
            getBySelector('#slcFilterSelectLayer').value = bookmarkPresentationName


            const hasBuffer = getBySelector('layer-info-info-geometry-measure-buffer input')
            if(hasBuffer) {
                getBySelector('#iptFilterSelectLayer').value = hasBuffer.value
            }

            addFilterSelectLayerItem(window.result)
        }
    } else {
        if(window.drawMeasureVectorSource) {
            addFilterSelectLayerItem(window.result, window.drawMeasureVectorSource.getFeatures()[0])
        }
    }
}

export function LoadFilterSelectOptions() {

    let drawFeatures
    if(window.drawMeasureVectorSource) {
        drawFeatures = window.drawMeasureVectorSource.getFeatures()
    }

    const activeFilter = getActiveFilter()
    const element = getBySelector('#slcFilterSelectLayer')
    if(activeFilter && element ) {
        let options = '<option value="">Kies mijn laag</option>'


        if(drawFeatures && drawFeatures.length > 0) {
            options += `<option value="drawMeasure" selected="selected">Getekende laag</option>`
        }

        getActiveLayers().map(layer => {
            // Niet mogelijk maken om eigen laag te selecteren
            // Moet wel mogelijk zijn voor een eigen buffer //  && layer.ID !== activeFilter.BookmarkPresentationID
            if(layer && layer.Type === 'WMS') {
                options += `<option value="${layer.ID}">${layer.DisplayName}</option>`
            }
        })

        if(element) {
            element.innerHTML = options
        }
    }
}
